export default "__VITE_ASSET__BQDp_OqL__"